var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 233,
    viewBox: "0 0 92 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4212 232.557H0.286133V226.358H33.4212C44.2329 226.358 53.029 217.579 53.029 206.787V26.2124C53.029 15.4211 44.2329 6.64161 33.4212 6.64161H0.416053V0.442871H33.4212C47.6567 0.442871 59.2395 12.0038 59.2395 26.2124V206.787C59.2395 220.996 47.6567 232.557 33.4212 232.557Z",
    fill: "#3E6592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.7377 116.534L71.5684 104.35V128.714L91.7377 116.534Z",
    fill: "#3E6592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.1179 112.409H54.0393V120.658H83.1179V112.409Z",
    fill: "#3E6592"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group (2).0f9e87dd868e178864719f448ffb2e76.svg";
export { ForwardRef as ReactComponent };